
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { contentUtils } from '@/lib/content-utils';
import { badgeVariants } from '@/lib/design-tokens';

interface StudentStatusBadgeProps {
  status: 'active' | 'waitlisted' | 'withdrawn' | 'completed' | 'inactive';
}

const StudentStatusBadge: React.FC<StudentStatusBadgeProps> = ({ status }) => {
  const statusVariant = badgeVariants[status] || badgeVariants.inactive;
  const label = contentUtils.formatStatus(status, 'student');

  return (
    <Badge 
      className={statusVariant.classes}
      variant="outline"
    >
      {label}
    </Badge>
  );
};

export default StudentStatusBadge;
